/**
 * Profilo EDIL-TEST (Edilcostruzioni - ambiente di collaudo).
 *
 * File PRIVATO - gitignorato. Distribuito al team via canale privato.
 *
 * Uso:
 *   ng serve --configuration=edil-test
 *   ng build --configuration=edil-test
 */
import { AppEnvironment, sharedEnvironment } from '@env-shared';
import { edilCompanyUiConfig } from './environment.edil';

export const environment: AppEnvironment = {
	...sharedEnvironment,
	production: false,
	profile: 'edil-test',

	base_url_browser: 'https://api.collaudo.edilcostruzioni.kondorcs.com',
	base_url: 'https://api.collaudo.edilcostruzioni.kondorcs.com',

	imageBaseURL: 'https://app.collaudo.edilcostruzioni.kondorcs.com/assets',

	apiGoogleMapsKey: 'AIzaSyAaQ4-aPwqJ1JZojJsRUR5RdqQy0_u5IBE',
	paypal_clientId: 'AS18bscPjfHsLX8NnsYmM0YOw1CEqtS1HQFFIFmllt9RX5g4HpORMhAXS4QDYqv8pQOFZ97GNuuok50G',
	nexi_script: 'https://int-ecommerce.nexi.it/ecomm/XPayBuild/js?alias=ALIAS_WEB_00054558',

	companyUiConfig: edilCompanyUiConfig,

	// Build white-label Edilcostruzioni: niente logo MyTown ne' banner FESR/UE
	showFundingBranding: false,

	// Accesso da collaudo.edileasy.com: logo EdilEasy al login e ingresso nell'azienda EdilEasy.
	// companyId 24 = azienda EdilEasy creata in collaudo il 2026-10-30.
	domainBranding: {
		'collaudo.edileasy.com': { loginLogo: 'assets/images/edileasy_logo.svg', companyId: 24 },
	},
};
